import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';

// import { HomeComponent } from './pages/home/home.component';
// import { ProfileComponent } from './pages/profile/profile.component';
// import { AboutComponent } from './pages/about/about.component';
// import { AdminComponent } from './pages/admin/admin.component';
// import { HelpComponent } from './pages/help/help.component';
// import { NotFoundComponent } from './pages/not-found/not-found.component';
import { AppRoutingModule } from '../app-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { BhubTopBarComponent } from '../bhub-top-bar/bhub-top-bar.component';

/**
 * This Module houses the board that users will see upon entering the application. It will contain a navigation pane at the top
 * and house the content of the application via a series of pages.
 */
@NgModule({
  declarations: [
    // HomeComponent,
    // ProfileComponent,
    // AboutComponent,
    // AdminComponent,
    // HelpComponent,
    // NotFoundComponent,
    // BhubSidebarComponent,
    // BhubPageHolderComponent,
    BhubTopBarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatSidenavModule,
    MatButtonModule,
    MatMenuModule,
    MatDividerModule,
    MatToolbarModule,
    MatTabsModule,
    MatTableModule,
    AppRoutingModule
  ],
  providers: [
  ],
  exports: [
    BhubTopBarComponent
  ]
})
export class BhubTopBarModule { }
